import { Component, Input } from '@angular/core';
import { Organisation } from '../../../models/types';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-add-org-images-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './add-org-images-modal.component.html',
  styleUrl: './add-org-images-modal.component.scss'
})
export class AddOrgImagesModalComponent {

  @Input() organisation!: Organisation; // Organisation object to which the images will be added
  imageFiles: File[] = [];
  previewImageSrcs: string[] = [];
  faImage = faImage;

  constructor(private organisationService: OrganisationServiceService,
    private activeModal: NgbActiveModal
  ) { }

  addOrgImages(): void {
    if (this.imageFiles.length > 0) {
      this.organisationService.addOrgImages(this.organisation, this.imageFiles).subscribe(
        (response) => {
          console.log('Organisation images added successfully:', response);
          this.activeModal.close();
          window.location.reload();
        },
        (error) => {
          console.error('Error adding organisation images:', error);
        }
      );
    } else {
      alert('Please select at least one image to upload.');
    }
  }

  onImageUploadChanged(event: any) {
    const files: FileList = event.target.files;
  
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileType = file.type.toLowerCase();
  
        // Validate file type
        if (!['image/jpeg', 'image/jpg', 'image/png'].includes(fileType)) {
          console.log('Unsupported file type:', fileType);
          Swal.fire({
            icon: 'warning',
            title: 'Napačen format slike',
            text: 'Podprti formati slik so JPG, JPEG in PNG. Prosimo, poskusite znova.',
          });
          continue;
        }
  
        // Compress the image before adding it
        this.organisationService.compressImage(file, 70, 70).then((compressedFile) => {
          this.imageFiles.push(compressedFile);
          this.previewImageSrcs.push(URL.createObjectURL(compressedFile));
        }).catch(error => {
          console.error('Error compressing image:', error);
        });
      }
    }
  }
  
  
  removeImage(index: number): void {
    // Remove the file from the imageFiles array
    this.imageFiles.splice(index, 1);
    
    // Remove the corresponding preview URL
    this.previewImageSrcs.splice(index, 1);
  }
  
  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
